// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"d78b7a93","237":"8dcadd28","241":"2591ce9a","319":"29d69017","428":"a9990fdf","479":"a4d05d53","506":"31052079","535":"c82c0034","581":"8f67a79e","594":"e45bee4a","638":"abf79046","791":"e567aeb6","839":"99b6c2ae","881":"cb43443b"}[chunkId] + ".chunk.js";
};